
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/cadent",
      function () {
        return require("private-next-pages/destinations/cadent.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/cadent"])
      });
    }
  